// Client-side helpers shared by the browse pages: trust filters, car / property detail filters, and the one-line
// "spec summary" shown on listing cards.  (lib/attrFilters.js is the server twin used by saved-search alerts.)
export const attrVal = (p, key) => { const a = (p.attributes || []).find((x) => x.key === key); return a && a.value != null ? String(a.value) : ""; };
const num = (v) => { const n = parseFloat(String(v ?? "").replace(/[^0-9.]/g, "")); return Number.isFinite(n) ? n : null; };
const count = (v) => (/more than|\+/i.test(String(v || "")) ? 99 : num(v));
const eq = (a, b) => String(a || "").trim().toLowerCase() === String(b || "").trim().toLowerCase();

export const emptyExtra = () => ({ escrowOnly: false, verifiedOnly: false, minRating: 0, attrs: {} });
export const extraCount = (e) => (e.escrowOnly ? 1 : 0) + (e.verifiedOnly ? 1 : 0) + (e.minRating ? 1 : 0) + Object.values(e.attrs || {}).filter((v) => v !== "" && v != null).length;

// Detail filters per top-level category (what the sidebar offers when that category is ticked)
export const DETAIL_FILTERS = {
  vehicles: [
    { key: "make", label: "Make", type: "text", placeholder: "e.g. Toyota" },
    { key: "model", label: "Model", type: "text", placeholder: "e.g. Camry" },
    { key: "yearMin", label: "Year from", type: "number", placeholder: "2012" },
    { key: "yearMax", label: "Year to", type: "number", placeholder: "2024" },
    { key: "mileageMax", label: "Max mileage (km)", type: "number", placeholder: "100000" },
    { key: "transmission", label: "Transmission", type: "select", options: ["Automatic", "Manual"] },
    { key: "fuel", label: "Fuel", type: "select", options: ["Petrol", "Diesel", "Hybrid", "Electric", "CNG / LPG"] },
    { key: "origin", label: "Registration / origin", type: "select", options: ["Foreign used (Tokunbo)", "Nigerian used", "Brand new"] },
  ],
  property: [
    { key: "bedroomsMin", label: "Bedrooms (min)", type: "select", options: ["1", "2", "3", "4", "5", "6"] },
    { key: "bathroomsMin", label: "Bathrooms (min)", type: "select", options: ["1", "2", "3", "4", "5"] },
    { key: "furnishing", label: "Furnishing", type: "select", options: ["Furnished", "Semi-furnished", "Unfurnished"] },
    { key: "rentPeriod", label: "Rent is paid", type: "select", options: ["Per year", "Per month", "Per week", "Per day"] },
    { key: "parking", label: "Parking", type: "select", options: ["Yes", "No"] },
    { key: "serviced", label: "Serviced", type: "select", options: ["Yes", "No"] },
  ],
};

export function matchAttrs(p, a = {}) {
  const need = (v) => v !== "" && v != null;
  if (need(a.make) && !attrVal(p, "make").toLowerCase().includes(String(a.make).toLowerCase())) return false;
  if (need(a.model) && !attrVal(p, "model").toLowerCase().includes(String(a.model).toLowerCase())) return false;
  if (need(a.yearMin) && !(num(attrVal(p, "year")) >= Number(a.yearMin))) return false;
  if (need(a.yearMax) && !(num(attrVal(p, "year")) <= Number(a.yearMax))) return false;
  if (need(a.mileageMax) && !(num(attrVal(p, "mileage")) <= Number(a.mileageMax))) return false;
  for (const k of ["transmission", "fuel", "origin", "furnishing", "rentPeriod", "parking", "serviced"]) if (need(a[k]) && !eq(attrVal(p, k), a[k])) return false;
  if (need(a.bedroomsMin) && !(count(attrVal(p, "bedrooms")) >= Number(a.bedroomsMin))) return false;
  if (need(a.bathroomsMin) && !(count(attrVal(p, "bathrooms")) >= Number(a.bathroomsMin))) return false;
  return true;
}

export function matchExtra(p, e) {
  const t = p.trust || {};
  if (e.escrowOnly && !t.escrow) return false;
  if (e.verifiedOnly && !t.verified) return false;
  if (e.minRating && !((t.rating || 0) >= e.minRating)) return false;
  return matchAttrs(p, e.attrs);
}

const n0 = (v) => { const n = num(v); return n == null ? "" : n.toLocaleString("en-NG"); };
// "2016 · 85,000 km · Automatic"  /  "3 bed · 2 bath · Furnished"  /  first few details for everything else
export function specSummary(p) {
  const v = (k) => attrVal(p, k);
  const cat = String(p.category || "").toLowerCase();
  let parts = [];
  if (cat === "vehicles") parts = [v("year"), v("mileage") && `${n0(v("mileage"))} km`, v("transmission"), v("fuel")];
  else if (cat === "property") parts = [v("bedrooms") && `${v("bedrooms")} bed`, v("bathrooms") && `${v("bathrooms")} bath`, v("furnishing"), v("size") && `${v("size")} sqm`, v("rentPeriod")];
  else parts = (p.attributes || []).slice(0, 3).map((a) => String(a.value));
  return parts.filter(Boolean).slice(0, 4).join(" · ");
}

export const replyLabel = (mins) => (mins == null ? "" : mins < 60 ? "Replies within the hour" : mins < 24 * 60 ? `Replies in ~${Math.max(1, Math.round(mins / 60))}h` : "Replies in ~1 day");
